import ApiBuilder from "./ApiBuilder"
const { API } = ApiBuilder

const getAllApiResources = () => {
  return API.get(`/api/lookup/api-resources`)
}

const getAllApplicationCategories = () => {
  return API.get(`/api/lookup/app-category`)
}

const getProductPropertyFormats = (categoryName) => {
  return API.get(`/api/lookup/product-property-formats?categoryName=${categoryName}`)
}

const getAllPlatforms = () => {
  return API.get(`/api/lookup/platforms`)
}

const getAllProductStatuses = () => {
  return API.get(`/api/lookup/product-statuses`)
}

const getAllProductTypes = () => {
  return API.get(`/api/lookup/product-types`)
}

const getAllContractTypes = (platformId) => {
  return API.get(`/api/lookup/contract-types/${platformId}`)
}

export default {
  getAllApiResources,
  getAllApplicationCategories,
  getProductPropertyFormats,
  getAllPlatforms,
  getAllProductStatuses,
  getAllProductTypes,
  getAllContractTypes
}